
///<reference path="../../App/plugins/DefinitelyTyped/bootstrap-select.d.ts"/>
///<reference path="../../App/plugins/DefinitelyTyped/bootstrap.multiselect.d.ts"/>
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { DatePipe } from "@angular/common";
import { MySharedService } from '../App/shared.service';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
    templateUrl: './AppViews/ChangeRequest/ChangeRequestLinkThankYou.html'
})

export class ChangeRequestLinkThankYouComponent implements OnInit {

    constants: Constants;
    ChangeRequestDetails: any = [];
    isCommercialEdit: any = 0;
    userDetail: any;
    userDetailById: any
    showUsertab: boolean = false;
    addUpdateChangeRequest: any = {'Description' :"",'ProjectId':"",'ModuleId': "",'RequestedBy':"", 'RespondedByName':"",'StatusId': "", 'Comments': ""};
    addUpdateChangeFormActive: any = true;
    public showLoader = false;
    projects: any = [];
    IssueModuleList: any = [];
    severityItems: any = [];
    priorityItems: any = [];
    statusItems: any = [];
    catagoryItems: any = [];
    users: any = [];
    issueItems: any = [];
    public isaddUpdateChangeRequestFormSubmitted: boolean = false;
    public isFormSubmitted: boolean = false;
    projectItems: any = [];
    issueStatusItems: any = [];
    issueStageItems: any = [];
    issuePriorityItems: any = [];
    issueCatagoryItems: any = [];
    issueSeverityItems: any = [];
    issueAssigneeItems: any = [];
    issueReporterItems: any = [];
    updateIssue: any = {};
    reportedDate: number = 0;
    isEditableStatus: boolean = false;
    isEditableForAssignee: boolean = false;
    isEditableForStatus: boolean = false;
    isEditableForReporter: boolean = false;
    isEditableIssue: boolean = true;
    isEditable: boolean = true;
    fileList: any = [];
    remarkListItems: any = [];
    ChangeRequestLog: any =[];
    UserReportedBy:String;
    
    ScreenshotPath:any;
    constructor(private _httpService: HTTPService, private _sharedService: MySharedService, private _datepipe: DatePipe, private route: ActivatedRoute, private _route: Router) {
      
        this.constants = new Constants();
   // this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
  // this.userDetail.SiteUserId = 1;
        
      
       
        
    }
    ngOnInit() {

    //    this.bindDropdownsData();
    //    if (this.ChangeRequestDetails.ChangeRequestId != 0) {
       
    //     debugger
    //      this.getChangeRequest();
    //    }
    //  if (this.ChangeRequestDetails.ChangeRequestId == 0) {
      
    //      this.addUpdateChangeRequest = {'Description' :"",'ProjectId':"",'ModuleId': "",'RequestedBy':"", 'RespondedByName':"",'StatusId': "", 'Comments': ""};
    //     // this.addUpdateChangeRequest.ReportedBy=this.userDetail.SiteUserId;
    //    //  this.UserReportedBy= this.userDetail.Name; 
    //      //  this.isEditable = false;
    //     //   this.isEditableIssue  = false;
         
    //  }


    }


    bindDropdownsData() {
        this.showLoader = true;
      
this._httpService.ajaxPost('Common/GetParameter',
                    { "ParameterTypeId": this.constants.enumParamterTypeName["ServiceRequestStatusType"] }).subscribe(
                    data => {
                        this.statusItems = data["Parameter"];
                        this.statusItems= this.statusItems.filter(m1 => m1.Value != 1 &&  m1.Value != 2);
                        
                    },
                    err => {
                        this.showLoader = false;
                    },
                     () => {
                        this.showLoader = false;
                         }
 
                    ); this.showLoader = false;
  }

    public getChangeRequest() {
        this.showLoader = true;
        if(this.isCommercialEdit!=0){
           
            this._httpService.ajaxPost("ChangeRequest/authoriseRequest", { "ChangeRequestId": this.ChangeRequestDetails.ChangeRequestId }).subscribe(
                data => {
                    // if(data["IssueItems"] != null)
                   
                    this._httpService.ajaxPost("ChangeRequest/getChangeRequest", { "ChangeRequestId": this.ChangeRequestDetails.ChangeRequestId }).subscribe(
                        data => {
                            // if(data["IssueItems"] != null)
                           
                            this.addUpdateChangeRequest = data["ChangeRequest"][0];
                            this.ChangeRequestLog =data["ChangeRequestLog"];
                            this.addUpdateChangeRequest.Description = this.ChangeRequestLog.filter(element => element.CommentType == 409)[0].Comment;
                            this.ChangeRequestLog =this.ChangeRequestLog.filter(element => element.CommentType != 409);
                            this.ChangeRequestLog.filter(m1 => m1.CommentType == 406).forEach(c => c.CommentTypeName = "Emqube Comment");
                            this.ChangeRequestLog.filter(m1 => m1.CommentType == 407).forEach(c => c.CommentTypeName = "Client Comment");
                        
                        },
                        err => {
                            this.showLoader = false;
                            this._sharedService.ShowMessage(this.constants.globalError);
                        },
            
                        () => {
            
                            this.GetModule(this.addUpdateChangeRequest.ProjectId,null);
                            this.showLoader = false;
                              }
            
                             );
              
                },
                err => {
                    this.showLoader = false;
                    this._sharedService.ShowMessage(this.constants.globalError);
                },
    
                () => {
    
                  
                    this.showLoader = false;
                      }
    
                     );                        }
                   
                    else{
                        this._httpService.ajaxPost("ChangeRequest/getChangeRequest", { "ChangeRequestId": this.ChangeRequestDetails.ChangeRequestId }).subscribe(
                            data => {
                                // if(data["IssueItems"] != null)
                               
                                this.addUpdateChangeRequest = data["ChangeRequest"][0];
                                this.ChangeRequestLog =data["ChangeRequestLog"];
                                this.addUpdateChangeRequest.Description = this.ChangeRequestLog.filter(element => element.CommentType == 409)[0].Comment;
                                this.ChangeRequestLog =this.ChangeRequestLog.filter(element => element.CommentType != 409);
                                this.ChangeRequestLog.filter(m1 => m1.CommentType == 406).forEach(c => c.CommentTypeName = "Emqube Comment");
                                this.ChangeRequestLog.filter(m1 => m1.CommentType == 407).forEach(c => c.CommentTypeName = "Client Comment");
                            },
                            err => {
                                this.showLoader = false;
                                this._sharedService.ShowMessage(this.constants.globalError);
                            },
                
                            () => {
                
                                this.GetModule(this.addUpdateChangeRequest.ProjectId,null);
                                this.showLoader = false;
                                  }
                
                                 );
                    }
     }
public CancelScreanShot() {
 
        $('#ViewScreanShot').modal('hide');
  
    }  

changeStatus(AssignedToId){


 
if((AssignedToId !="")&&( this.addUpdateChangeRequest.StatusId==1)){
    
    this.addUpdateChangeRequest.StatusId=2;
    this.showLoader = false;
    this.isEditableForStatus= false;
    this.issueStatusItems =this.issueStatusItems.filter(item => item.Value != 1);


}
else if((AssignedToId =="")&&(this.ChangeRequestDetails.ChangeRequestId == 0))
{
    
     this.addUpdateChangeRequest.StatusId=1;
      this.showLoader = false;

}

    this.showLoader = false;

}
    GetModule(ProjectId,from) {

      this.showLoader = true;

          this._httpService.ajaxPost("ProjectModule/GetProjectModule",
            { "ProjectId": ProjectId }).subscribe(
            data => {
                if(from == 1) 
               { this.addUpdateChangeRequest.ModuleId="";
            }
                  if(data["ProjectModuleList"].length >0){
                this.IssueModuleList = data["ProjectModuleList"];
                  }
                  else{
                       let objItem: any = {};
                   
                    objItem.ProjectId = ProjectId;
                    objItem.ModuleName = "Main";;
                  //  objItem.ModuleId =0;
                   
             this._httpService.ajaxPost('ProjectModule/AddUpdateProjectModule',objItem).subscribe(
             data => {

                this.GetModule(ProjectId,null);
                 this.addUpdateChangeRequest.ModuleId="";
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },

            () => {
                this.showLoader = false;
            }
        );
                  }
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },

            () => {
                this.showLoader = false;
            }

            );
           

    }

   
   

   

    AddUpdateChangeRequestTab(form: any) {
        this.isaddUpdateChangeRequestFormSubmitted = true;
            

           this.showLoader = true;
           this.addUpdateChangeRequest.CommentType =2;
           console.log("this.addUpdateChangeRequest:"+this.addUpdateChangeRequest);
            this._httpService.ajaxPost('ChangeRequest/addUpdateChangeRequestComment', this.addUpdateChangeRequest).subscribe(
                data => {

                    var msg = data["Status"].Message.split('|');
                   
                    if (msg.length >= 1) {

                        msg[0] = msg[0].toLowerCase();
                        if (msg[0] == "success") {
                            
                            this._sharedService.ShowMessage(msg[0] + "|" + msg[1]);
                            this.isCommercialEdit=0;
                             this.getChangeRequest();
                        }
                        else if (msg[0] == "warning") {
                            this._sharedService.ShowMessage(msg[0] + "|" + msg[1]);
                        }
                        else {
                         
                            this._sharedService.ShowMessage(this.constants.globalError);
                        }
                    }
                    else {
                    }
                },
                err => {
                    this.showLoader = false;
                  
                    this._sharedService.ShowMessage(this.constants.globalError);
                },

                () => {
                    this.showLoader = false;
                }
            );
       
    }





}



/** WEBPACK FOOTER **
 ** ./TypeScripts/ChangeRequest/ChangeRequestLinkThankYou.component.ts
 **/